// InvoiceService.tsx
import { BaseService } from '../../core/BaseService';
import { DeleteData, PaginationParams } from '../../type';
import {
  ConsolidatedInvoiceRequest,
  CreateSalesCreditNoteRequest,
  GetCreditNoteByIdResponse,
  GetDeliveryNoteByIdResponse,
  GetDeliveryNotesResponse,
  GetICreditNoteResponse,
  GetInvoiceByIdResponse,
  GetInvoiceItemsByIdResponse,
  GetInvoiceResponse,
  GetInvoiceTemplateByIdResponse,
  GetInvoiceTemplatesListResponse,
  GetInvoiceTemplatesResponse,
  GetInvoicesByClientRequest,
  GetInvoicesByClientResponse,
  GetReviewByIdResponse,
  InvoiceTemplate,
  SalesCreditNoteResponse,
} from './interface';

export class InvoiceProfile extends BaseService {
  async getInvoice(params: PaginationParams) {
    return this.get<GetInvoiceResponse>(`${this.apiUrl}/api/invoices/paged`, params);
  }

  async getInvoiceByID(id: number) {
    return this.get<GetInvoiceByIdResponse>(`${this.apiUrl}/api/invoices/${id}`);
  }

  async getCreditNotes(params: PaginationParams) {
    return this.get<GetICreditNoteResponse>(`${this.apiUrl}/api/creditnotes/paged`, params);
  }

  async getInvoicesByClient(req: GetInvoicesByClientRequest) {
    return this.get<GetInvoicesByClientResponse>(`${this.apiUrl}/api/invoices/get`, req);
  }

  async getInvoiceItemsById(id: number) {
    return this.get<GetInvoiceItemsByIdResponse>(`${this.apiUrl}/api/invoices/items/${id}`);
  }

  async createSalesCreditNote(req: CreateSalesCreditNoteRequest) {
    return this.post<SalesCreditNoteResponse, CreateSalesCreditNoteRequest>(`${this.apiUrl}/api/creditnotes`, req);
  }

  async getInvoiceTemplatesDropdown(params: PaginationParams) {
    return this.get<GetInvoiceTemplatesResponse>(`${this.apiUrl}/api/invoicetemplates/get`, params);
  }

  async createInvoiceTemplate(req: InvoiceTemplate) {
    return this.post<InvoiceTemplate, InvoiceTemplate>(`${this.apiUrl}/api/invoicetemplates`, req);
  }

  async updateInvoiceTemplate(req: InvoiceTemplate) {
    return this.put<GetInvoiceTemplateByIdResponse, InvoiceTemplate>(`${this.apiUrl}/api/invoicetemplates/update`, req);
  }

  async deleteInvoiceTemplate(id: number) {
    return this.delete<DeleteData>(`${this.apiUrl}/api/invoicetemplates/${id}`);
  }

  async getInvoiceTemplateByID(id: number) {
    return this.get<GetInvoiceTemplateByIdResponse>(`${this.apiUrl}/api/invoicetemplates/${id}`);
  }

  async getInvoiceTemplates(params?: PaginationParams) {
    return this.get<GetInvoiceTemplatesListResponse>(`${this.apiUrl}/api/invoicetemplates/paged`, params || {});
  }

  async setDefaultInvoiceTemplate(id: number) {
    return this.put<GetInvoiceTemplateByIdResponse, {}>(`${this.apiUrl}/api/invoicetemplates/${id}/set-default`, {});
  }

  async getDeliveryNotes(params: PaginationParams) {
    return this.get<GetDeliveryNotesResponse>(`${this.apiUrl}/api/deliverynotes/paged`, params);
  }

  async createConsolidatedInvoices(req: ConsolidatedInvoiceRequest) {
    return this.post<GetInvoiceByIdResponse, ConsolidatedInvoiceRequest>(
      `${this.apiUrl}/api/invoices/deliverynotes`,
      req
    );
  }

  async getReviewByID(id: number | undefined) {
    return this.get<GetReviewByIdResponse>(`${this.apiUrl}/api/reviews/${id}`);
  }

  async getCreditNoteById(id: number) {
    return this.get<GetCreditNoteByIdResponse>(`${this.apiUrl}/api/creditnotes/${id}`);
  }

  async getDeliveryNoteByID(id: number) {
    return this.get<GetDeliveryNoteByIdResponse>(`${this.apiUrl}/api/deliverynotes/${id}`);
  }
}
